import { VAlert } from 'vuetify/lib/components/VAlert';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VAlert,{staticClass:"text-left",attrs:{"type":"info","dense":"","rounded":"","text":"","outlined":""}},[_vm._v(" "+_vm._s(_vm.$t('delivery.mode.estimatedTime', {hour: _vm.hour}))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }